import React from 'react';
import { componentService } from 'js/services/component.service';

export const KnowledgeBasedAuthentication = React.lazy(() => import(/* webpackChunkName: "knowledge-based-authentication" */ './KnowledgeBasedAuthentication'));

componentService.registerPageComponents({ kba: KnowledgeBasedAuthentication });
